import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "sohailmh",
    aws_cognito_region: "us-east-1",
    aws_cognito_identity_pool_id: "us-east-1:3ca37ad6-5fe6-4d01-b02d-5989bc03a027",
    aws_user_pools_id: "us-east-1_6pQMi9NvH",
    aws_user_pools_web_client_id: "6f9c8qilfsi4m1snjv4p3ihnsi",
    Auth: {
      identityPoolId: "us-east-1:3ca37ad6-5fe6-4d01-b02d-5989bc03a027",
      region: "us-east-1",
      userPoolId: "us-east-1_6pQMi9NvH",
      userPoolWebClientId: "6f9c8qilfsi4m1snjv4p3ihnsi",
    },
    oauth: {
      domain: `whs-eap-beta-na.auth.us-east-1.amazoncognito.com`,
      redirectSignIn: "https://sohailmh.na.safety-genie.whs.amazon.dev",
      redirectSignOut: "https://sohailmh.na.safety-genie.whs.amazon.dev",
      scope: ["openid", "email", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
